import { FC } from 'react';

import { ButtonToggle, Flex } from '@servicetitan/anvil2';

interface AgentSuggestedPromptsProps {
    prompts: string[];
    onSelect: (prompt: string) => void;
}

/*
 * Clickable opening prompts for the Field Pro Coach chat. Unlike question-picker's QuestionsOptions
 * these are plain strings with no store coupling — selecting one just sends it as the user's message.
 */
export const AgentSuggestedPrompts: FC<AgentSuggestedPromptsProps> = ({ prompts, onSelect }) => (
    <Flex className="w-100" wrap="wrap" gap="1">
        {prompts.map(prompt => (
            <ButtonToggle className="m-b-1" key={prompt} onClick={() => onSelect(prompt)}>
                {prompt}
            </ButtonToggle>
        ))}
    </Flex>
);
